import { ReactNode } from "react"

import * as Collapsible from "@/ui/collapsible"
import { Prose } from "@/ui/prose"
import { Text } from "@/ui/text"

export function Accordion({
  title,
  children,
}: {
  title: string
  children?: ReactNode
}) {
  return (
    <Collapsible.Root bordered>
      <Collapsible.Trigger
        className="group"
        css={{
          display: "flex",
          alignItems: "center",
          gap: "$6",
          py: "$6",
        }}
      >
        <Text color="accent" link="group">
          <Collapsible.Indicator />
        </Text>
        <Text as="h3" size="xl" weight="bold" color="accent" link="group">
          {title}
        </Text>
      </Collapsible.Trigger>
      <Collapsible.Content>
        <Prose css={{ mb: "$6", maxWidth: 800 }} size="lg" color="muted">
          {children}
        </Prose>
      </Collapsible.Content>
    </Collapsible.Root>
  )
}
